// extracted by mini-css-extract-plugin
export default {"card":"pipeline-graph-v2_card__Z2Ofn","container":"pipeline-graph-v2_container__pnWsD"};